import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

// TEMPORARY (owner-authorized 2026-09-15): one-time purge of all test submissions. Remove after use.
export default function PurgePanel() {
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  const run = async () => {
    if (confirm !== "PURGE") { toast.error("Type PURGE to confirm"); return; }
    if (!window.confirm("Permanently delete ALL current submissions and their uploaded files? This cannot be undone.")) return;
    setBusy(true);
    try {
      const r = await api.post("/admin/maintenance/purge-test-data", { confirm });
      setResult(r.data);
      toast.success(`Deleted ${r.data.leads_deleted} submissions`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Purge failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="card-frame p-6 mt-8 border-red-900/40" data-testid="purge-panel">
      <div className="overline text-red-400">Temporary · Purge test data</div>
      <p className="text-sm text-neutral-400 mt-2">Permanently deletes every Seller, Buyer, Investor and Contact submission that exists right now, plus their verification/status data, file records and stored files. Records created after you click are kept. Sends nothing, retries nothing.</p>
      <div className="mt-4 flex flex-wrap items-center gap-3">
        <input value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Type PURGE" className="bg-black/40 border border-white/10 px-3 py-2 text-sm" data-testid="purge-confirm-input" />
        <button onClick={run} disabled={busy || confirm !== "PURGE"} className="btn-gold px-5 py-2.5 text-sm font-semibold disabled:opacity-40" data-testid="purge-run-button">
          {busy ? "Purging…" : "Purge all test submissions"}
        </button>
      </div>
      {result && (
        <div className="mt-5 text-sm text-neutral-200 space-y-1" data-testid="purge-result">
          <div>Cutoff: <span className="text-neutral-400">{result.cutoff}</span></div>
          <div>Submissions deleted: <b>{result.leads_deleted}</b> ({Object.entries(result.by_type || {}).map(([k, v]) => `${k}: ${v}`).join(", ") || "none"})</div>
          <div>File records deleted: <b>{result.file_records_deleted}</b> · storage objects neutralized: <b>{result.storage_objects_neutralized}</b> · storage failures: <b>{result.storage_failed?.length || 0}</b></div>
          <div>Remaining submissions: <b>{result.remaining_submissions}</b></div>
        </div>
      )}
    </div>
  );
}
